import { render, staticRenderFns } from "./BlockLine.vue?vue&type=template&id=3b5f4e8e&scoped=true&"
import script from "./BlockLine.vue?vue&type=script&lang=js&"
export * from "./BlockLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f4e8e",
  null
  
)

export default component.exports